<template>
<v-dialog
    v-model="dialog"
    max-width="920"
>
    <v-card>
        <v-card-title>{{title}}</v-card-title>

        <v-card-text>
            <div  v-html="text"/>
        </v-card-text>
        
        <v-card-actions>
        <v-btn
            text
            @click="onClickDismiss"
        >
            {{label_dismiss}}
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn
            text
            @click="onClickCancel"
            v-if="label_cancel != null"
        >
            {{label_cancel}}
        </v-btn>

        <v-btn
            color="primary"
            text
            @click="onClickOk"
        >
            {{label_ok}}
        </v-btn>
    </v-card-actions>

    </v-card>

</v-dialog>
</template>

<script>
const Validate = require('@/js/validate.js');
var Preconditions = require('@/js/Preconditions.js'); 

export default {

    data() {
        return {
            dialog: false,
            
            warning_code: null,
            title: '',
            text: '',

            label_ok: 'Ok',
            on_ok: null,

            label_cancel: 'Cancel',
            on_cancel: null,
            
            label_dismiss: 'Do not show again',
        }
    },

    created () {
        this.$event_bus.$on('warn', this.showDialog);
    },

    beforeDestroy () {
        this.$event_bus.$off('warn',this.showDialog);
    },

    methods: {

        showDialog(params) 
        {
            this.warning_code = params.warning_code.toLowerCase();
            this.title = params.title ?? 'Warning';
            this.text = params.text ?? 'You need to set the text field in params';
            this.label_ok = params.label_ok ?? 'Ok';
            this.on_ok = params.on_ok ?? (() => {});
            this.label_dismiss = params.label_dismiss ?? 'Do not show again';

            this.on_cancel = params.on_cancel ?? (() => {});
            this.label_cancel = params.label_cancel;

            
            if ( this.$rc.$state.isWarningDismissed(this.warning_code) )
            {
                this.on_ok();
                return;
            }

            this.dialog = true;
        },

        onClickOk()
        {
            this.dialog = false;
            this.on_ok();
        },
        
        onClickDismiss()
        {
            this.$rc.$state.dismissWarning(this.warning_code);
            this.onClickOk();
        },

        onClickCancel()
        {
            this.dialog = false;
            this.on_cancel();
        },
    },
}
</script>

<style lang="scss" scoped>
</style>